<div class="circle-container" *ngIf="count">
  <div class="circle" *ngIf="count > 1">+{{ count - 1 }}</div>
</div>
